import { render, staticRenderFns } from "./query.vue?vue&type=template&id=187fbc30&scoped=true"
import script from "./query.vue?vue&type=script&lang=js"
export * from "./query.vue?vue&type=script&lang=js"
import style1 from "./query.vue?vue&type=style&index=1&id=187fbc30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187fbc30",
  null
  
)

export default component.exports